import React, { useState } from "react";
import { Input, Modal, Typography } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import LabelValor from "../../../../components/label/LabelValor";
import { startUpdateServicio } from "../../../../context/actions/concesionariosActions";

const { Text, Title } = Typography;

export const CampoTextoEditable = ({ label, campo, valor }) => {
  const [openModal, setOpenModal] = useState(false);
  const [newValor, setNewValor] = useState("");
  const { id } = useParams();
  const dispatch = useDispatch();

  const handleOpen = () => {
    setNewValor(valor || "");
    setOpenModal(true);
  };

  const handleOk = () => {
    dispatch(startUpdateServicio({ [campo]: newValor }, id));
    setOpenModal(false);
  };

  return (
    <>
      <LabelValor
        labelStyle={{ cursor: "pointer", textDecoration: "underline dotted" }}
        onClick={handleOpen}
        label={label}
        valor={valor || ""}
      />
      <Modal
        title={<><EditOutlined className="campo-texto-editable-modal__title-icon" />Editar campo</>}
        onCancel={() => setOpenModal(false)}
        onOk={handleOk}
        open={openModal}
        wrapClassName="campo-texto-editable-modal"
        okText="Guardar"
        cancelText="Cancelar"
      >
        <div className="campo-texto-editable-modal__intro">
          <Title level={3} className="campo-texto-editable-modal__heading">
            {label}
          </Title>
          <Text type="secondary" className="campo-texto-editable-modal__description">
            Actualiza el valor de este campo del servicio.
          </Text>
        </div>
        <Input
          className="campo-texto-editable-modal__input"
          value={newValor}
          onChange={({ target }) => setNewValor(target.value)}
          placeholder={label}
        />
      </Modal>
    </>
  );
};
